<template>
    <div
        :is="isSubmittable ? 'form' : 'div'"
        class="form"
        :novalidate="noValidate"
        @submit.prevent="emitEvent({ name: 'submit', payload: $event })"
    >
        <slot></slot>

        <template v-if="$slots.footer">
            <div class="form__footer">
                <slot name="footer"></slot>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            isSubmittable: { type: Boolean, default: true },
            noValidate: { type: Boolean, default: false },
        },
    }
</script>
